import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import posthog from 'posthog-js';
import { config } from './config/env';

// Initialize PostHog
if (config.POSTHOG_API_KEY) {
    posthog.init(config.POSTHOG_API_KEY, {
        api_host: config.POSTHOG_HOST || 'https://us.i.posthog.com',
        autocapture: true,
        capture_pageview: false // We will handle pageviews manually or use the React plugin
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
